import { memberCountSingular } from "owa-locstrings/lib/strings/membercountsingular.locstring.json";
import { memberCountPlural } from "owa-locstrings/lib/strings/membercountplural.locstring.json";
import { privateGroupTooltip, publicGroupTooltip } from "./stringUtils.locstring.json";
import { privateAccessType } from "owa-locstrings/lib/strings/privateaccesstype.locstring.json";
import { publicAccessType } from "owa-locstrings/lib/strings/publicaccesstype.locstring.json";
import loc, { type LocalizedString, format as stringFormat } from "owa-localize";
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Baseline. Do not copy and paste"
 *	> '../index' import is restricted from being used. */
import type { GroupInformation } from "../index";
import type UnifiedGroupAccessType from "owa-service/lib/contract/UnifiedGroupAccessType";

export function getAccessTypeString(groupInformation: GroupInformation): LocalizedString {
    const accessType = groupInformation.groupDetails
        ? groupInformation.groupDetails.AccessType
        : groupInformation.basicInformation
            ? groupInformation.basicInformation.AccessType
            : null;
    
    if (accessType) {
        if (accessType === 1) {
            return loc(privateAccessType);
        }
        else if (accessType === 3) {
            return loc(publicAccessType);
        }
    }
    return "";
}

export function getAccessType(groupInformation?: GroupInformation): UnifiedGroupAccessType {
    const accessType = groupInformation?.groupDetails
        ? groupInformation.groupDetails.AccessType
        : groupInformation?.basicInformation
            ? groupInformation.basicInformation.AccessType
            : 0;
    return accessType ?? 0;
}

export function getAccessTypeTooltip(groupInformation: GroupInformation): string {
    const accessType = groupInformation.groupDetails
        ? groupInformation.groupDetails.AccessType
        : groupInformation.basicInformation
            ? groupInformation.basicInformation.AccessType
            : null;
    
    if (accessType) {
        if (accessType === 1) {
            return loc(privateGroupTooltip);
        }
        else if (accessType === 3) {
            return loc(publicGroupTooltip);
        }
    }
    return "";
}

export function getMembersButtonText(groupInformation: GroupInformation): string {
    let memberCount = 0;
    
    if (groupInformation.members) {
        memberCount = groupInformation.members.totalCount ?? 0;
    }
    else if (groupInformation.groupDetails) {
        memberCount = groupInformation.groupDetails.MemberCount ?? 0;
    }
    else if (groupInformation.basicInformation) {
        memberCount = groupInformation.basicInformation.AdditionalProperties?.MemberCount ?? 0;
    }
    
    if (memberCount === 0) {
        return "";
    }
    else if (memberCount > 1) {
        return stringFormat(loc(memberCountPlural), memberCount.toString());
    }
    else {
        return stringFormat(loc(memberCountSingular), memberCount.toString());
    }
}
